import { ComponentPropsWithRef, ReactNode, forwardRef } from 'react';

import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

import { useDialogContext } from '../DialogComposite/context';
import { DialogCompositeMui as DialogComposite } from '../DialogCompositeMui';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      flexShrink: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: theme.spacing(17),
      [theme.breakpoints.up('xs')]: {
        paddingTop: theme.spacing(15),
      },
    },
    rootFullScreen: {
      paddingTop: theme.spacing(4),
    },
  });

export type HeaderProps = WithStyles<typeof styles> &
  Omit<ComponentPropsWithRef<typeof DialogComposite.Header>, 'classes'> & {
    children?: ReactNode;
  };

export const Header = forwardRef<HTMLDivElement, HeaderProps>((props, ref) => {
  const { classes, children, className, ...rest } = props;
  const { props: dialogProps } = useDialogContext();
  const isFullScreen = Boolean(dialogProps?.fullScreen);

  return (
    <DialogComposite.Header
      ref={ref}
      className={classNames(classes.root, className, {
        [classes.rootFullScreen]: isFullScreen,
      })}
      {...rest}
    >
      {children}
    </DialogComposite.Header>
  );
});

Header.displayName = 'MultiStepDialog.Header';

const StyledHeader = withStyles(styles)(Header);
export default StyledHeader;
